
const PentaLevelData = [779, 829, 1088, 1098];
const HexaLevelData = [782];
const HeptaLevelData = [785];
const OctaLevelData = [789];
const NonaLevelData = [793];
const DecaLevelData = [796];

const NextLevel = ({ curCourseCode, curCourseName }: { curCourseCode: number, curCourseName: string }) => {
    
    const renderNextLevel = () => {
        if(PentaLevelData.includes(curCourseCode)) {
            return (
                <>
                <h4 className="care-indigo-header">다음은 Hexa 레벨에 대한 정보입니다.</h4>
                <div className="nextlevel-text-main">
                    <div>
                      <span className="nextlevel-text-indigo-700 font-bold block mb-1">[Listening]</span>
                      <p className="netxtlevel-common-text"><span className="font-bold">기초 표현 말하기에서 일상생활 관련 간단한 대화로:</span> 파닉스로 익힌 소리와 기본 표현을 활용해 자기소개·질문·대답 등 짧은 대화를 주고받는 연습이 강화됩니다.</p>
                    </div>
                    <div>
                      <span className="nextlevel-text-indigo-700 font-bold block mb-1">[Reading]</span>
                      <p className="netxtlevel-common-text"><span className="font-bold">알파벳·단어 읽기에서 패턴 문장 읽기와 간단한 스토리 이해로:</span> 낱말·문장 수준에서 벗어나, 같은 구조의 패턴 문장을 읽고 짧은 글의 흐름을 따라가는 연습을 시작합니다.</p>
                    </div>
                    <div>
                      <span className="nextlevel-text-indigo-700 font-bold block mb-1">[Vocabulary]</span>
                      <p className="netxtlevel-common-text"><span className="font-bold">단어 연습에서 패턴·문장 속 어휘 확장으로:</span> 패턴 문장과 읽기 지문 속에서 기초 어휘를 익히게 됩니다.</p>
                    </div>
                </div>
                </>
            );
        } else if(HexaLevelData.includes(curCourseCode)) {
            return (
                <>
                <h4 className="care-indigo-header">다음은 Hepta 레벨에 대한 정보입니다.</h4>
                <div className="nextlevel-text-main">
                    <div>
                      <span className="nextlevel-text-indigo-700 font-bold block mb-1">[Reading]</span>
                      <p className="netxtlevel-common-text"><span className="font-bold">패턴 리딩에서 스토리 이해로:</span> 같은 구조의 문장 읽기(Pattern Reading)에서 벗어나, 스토리가 있는 글을 읽고 이야기 전체를 이해하는 능력을 기르게 됩니다.</p>
                    </div>
                    <div>
                      <span className="nextlevel-text-indigo-700 font-bold block mb-1">[Grammar]</span>
                      <p className="netxtlevel-common-text"><span className="font-bold">문법 학습 시작 및 문장 구성 연습:</span> 문법을 배우기 시작하며, 기본 단어를 활용하여 간단한 문장을 스스로 만들어 보는 연습을 하게 됩니다.</p>
                    </div>
                </div>
                </>
            );
        } else if(HeptaLevelData.includes(curCourseCode)) {
            return (
                <>
                <h4 className="care-indigo-header">다음은 Octa 레벨에 대한 정보입니다.</h4>
                <div className="nextlevel-text-main">
                <div>
                      <span className="nextlevel-text-indigo-700 font-bold block mb-1">[Listening]</span>
                      <p className="netxtlevel-common-text"><span className="font-bold">이러닝 Dictation 강화:</span> 이러닝을 통해 리스닝 학습을 시작하며, 문제 풀이뿐만 아니라 받아쓰기(Dictation) 훈련으로 정확한 듣기 능력을 기릅니다.</p>
                    </div>
                    <div>
                      <span className="nextlevel-text-indigo-700 font-bold block mb-1">[Reading]</span>
                      <p className="netxtlevel-common-text"><span className="font-bold">비문학(Non-fiction) 독해력 심화:</span> 'Nonfiction Studies' 및 'Alex' 학습으로 비문학 지문 읽기를 강화합니다. 더 길어진 지문을 통해 **주제, 세부 정보, 순서 파악 등 읽기 전략(Reading Strategy)**을 학습합니다.</p>
                    </div>
                    <div>
                      <span className="nextlevel-text-indigo-700 font-bold block mb-1">[Vocabulary]</span>
                      <p className="netxtlevel-common-text"><span className="font-bold">어휘 확장 학습:</span> 단순 암기를 넘어, 파생어 학습을 통해 어휘력을 확장합니다.</p>
                    </div>
                    <div>
                      <span className="nextlevel-text-indigo-700 font-bold block mb-1">[Grammar]</span>
                      <p className="netxtlevel-common-text"><span className="font-bold">중등 문법 개념 및 실전 문제:</span> 중등 수준의 문법 개념을 단계별로 익히고, 이를 실전 문제 풀이에 적용하는 연습을 하게 됩니다.</p>
                    </div>
                </div>
                </>
            );
        } else if(OctaLevelData.includes(curCourseCode)) {
            return (
                <>
                <h4 className="care-indigo-header">다음은 Nona 레벨에 대한 정보입니다.</h4>
                <div className="nextlevel-text-main">
                <div>
                      <span className="nextlevel-text-indigo-700 font-bold block mb-1">[Listening]</span>
                      <p className="netxtlevel-common-text"><span className="font-bold">정규 수업 리스닝 시작:</span> 수업 시간에 정식 Listening 과목을 배우며, Unit별로 리스닝 전략(Listening Strategy)을 하나씩 체계적으로 학습합니다.</p>
                    </div>
                    <div>
                      <span className="nextlevel-text-indigo-700 font-bold block mb-1">[Reading]</span>
                      <p className="netxtlevel-common-text"><span className="font-bold">글 구조 파악 및 Summary:</span> 같은 주제의 지문(Pairing) 2개를 읽고 글의 구조를 분석하며 요약(Summary) 작성을 연습합니다. B학기에는 World History를 통해 비문학 독해를 더욱 심화합니다.</p>
                    </div>
                    <div>
                      <span className="nextlevel-text-indigo-700 font-bold block mb-1">[Vocabulary]</span>
                      <p className="netxtlevel-common-text"><span className="font-bold">토론 및 에세이 연계 학습:</span> A학기에는 Debate(토론), B학기에는 Paragraph Writing부터 Essay Writing을 학습하며, Speaking 수업 후에도 Writing이 연계되어 진행됩니다.</p>
                    </div>
                    <div>
                      <span className="nextlevel-text-indigo-700 font-bold block mb-1">[Vocabulary]</span>
                      <p className="netxtlevel-common-text"><span className="font-bold">어휘 확장 학습:</span> 단순 암기를 넘어, 파생어와 동의어 학습을 통해 어휘력을 확장합니다.</p>
                    </div>
                    <div>
                      <span className="nextlevel-text-indigo-700 font-bold block mb-1">[Grammar]</span>
                      <p className="netxtlevel-common-text"><span className="font-bold">고등 문법 및 실전 강화:</span> 고등 수준의 문법을 학습하고, 실전 문법 문제 풀이를 통해 실제 시험 적용 능력을 강화합니다.</p>
                    </div>
                </div>
                </>
            );
        } else if(NonaLevelData.includes(curCourseCode)) {
            return (
                <>
                <h4 className="care-indigo-header">다음은 Deca 레벨에 대한 정보입니다.</h4>
                <div className="nextlevel-text-main">
                <div>
                      <span className="nextlevel-text-indigo-700 font-bold block mb-1">[Listening & Speaking]</span>
                      <p className="netxtlevel-common-text"><span className="font-bold">Note-taking 및 통합 학습:</span> 강의 형식의 긴 지문을 듣고 핵심을 빠르게 기록하는 Note-taking 훈련을 시작합니다. Listening, Speaking, Reading이 연계된 교재로 통합적인 학습을 진행합니다.</p>
                    </div>
                    <div>
                      <span className="nextlevel-text-indigo-700 font-bold block mb-1">[Reading]</span>
                      <p className="netxtlevel-common-text"><span className="font-bold">학문적/장문 독해 심화:</span> 학문적 주제의 장문을 읽고 독해, 추론 능력, 비판적 사고를 훈련하는 학습을 하게 됩니다.</p>
                    </div>
                    <div>
                      <span className="nextlevel-text-indigo-700 font-bold block mb-1">[Vocabulary]</span>
                      <p className="netxtlevel-common-text"><span className="font-bold">수능 수준 어휘 완성:</span> 수능 수준의 어휘를 학습하며, 파생어와 동의어 학습을 통해 어휘 확장 연습을 지속합니다.</p>
                    </div>
                    <div>
                      <span className="nextlevel-text-indigo-700 font-bold block mb-1">[Grammar]</span>
                      <p className="netxtlevel-common-text"><span className="font-bold">고등 문법 심화 및 완성:</span> 고등 문법을 심화 학습하고 실전 문제 풀이를 통해 실전력을 극대화하여 고등 문법 수준을 완성합니다.</p>
                    </div>
                </div>
                </>
            );
        } else if(DecaLevelData.includes(curCourseCode)) {
            return (
                <>
                <h4 className="care-indigo-header">다음은 Hendeca 레벨에 대한 정보입니다.</h4>
                <div className="nextlevel-text-main">
                <div>
                      <span className="nextlevel-text-indigo-700 font-bold block mb-1">[Listening & Speaking]</span>
                      <p className="netxtlevel-common-text"><span className="font-bold">고급 강의 및 통합 학습:</span> Deca보다 더 긴 장문의 강의를 듣고 고급 어휘를 학습합니다. 이전 레벨과 동일하게 Listening/Speaking/Reading이 연계된 교재로 통합 수업을 진행합니다.
                      </p>
                    </div>
                    <div>
                      <span className="nextlevel-text-indigo-700 font-bold block mb-1">[Reading]</span>
                      <p className="netxtlevel-common-text"><span className="font-bold">TOEFL 수준 Writing:</span> TOEFL 시험 수준에 맞춰 Writing 연습을 심화합니다.</p>
                    </div>
                    <div>
                      <span className="nextlevel-text-indigo-700 font-bold block mb-1">[Vocabulary]</span>
                      <p className="netxtlevel-common-text"><span className="font-bold">수능/TOEFL 어휘 완성:</span> 수능 및 TOEFL 수준의 어휘를 학습하며, 파생어와 동의어를 통한 어휘 확장 연습을 지속합니다.</p>
                    </div>
                    <div>
                      <span className="nextlevel-text-indigo-700 font-bold block mb-1">[Grammar]</span>
                      <p className="netxtlevel-common-text"><span className="font-bold">수능/내신 문법 대비:</span> 수능 문법을 학습하고 실전 문제 풀이로 실전력을 강화하여 수능과 내신 준비를 동시에 진행합니다.</p>
                    </div>
                </div>
                </>
            );
        } else {
            return <div> - </div>
        }
    }

    return (
        <div className="care-indigo-card">
            <div className="care-flex-col-gap-lg care-text-base">
                {renderNextLevel()}
            </div>
        </div>
    )
}

export default NextLevel;